import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import { IRegistration } from '@app/modules/auth/interface/registration';
import { FormHelper } from '@app/shared/helpers/form';
import { IsEqualWith } from '@app/shared/validators/equal-value-validator';
import { PasswordValidator } from '@app/shared/validators/password';
import { PasswordType } from '@app/shared/types/password-type';
import { PinValidator } from '@app/shared/validators/pin';
import {IPasswordReset} from "@app/modules/auth/interface/password-reset";
import {customEmailValidator} from '@app/shared/validators/email';

@Component({
  selector: 'app-password-restore-withpin-confirm-form',
  templateUrl: './password-restore-withpin-confirm-form.component.html'
})
export class PasswordRestoreWithpinConfirmFormComponent implements OnInit {
  @Output() public submitEvent = new EventEmitter<IPasswordReset>();
  public isSubmitting = false;

  public form: FormGroup;

  public passwordRepeatType: PasswordType = 'password';

  public isProduction: boolean = environment.production;

  public get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  public get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  public get pin(): FormControl {
    return this.form.get('pin') as FormControl;
  }

  public get passwordRepeat(): FormControl {
    return this.form.get('passwordRepeat') as FormControl;
  }


  public get captcha(): FormControl {
    return this.form.get('captcha') as FormControl;
  }

  /**
   * @param fb
   */
  constructor(
    private readonly fb: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this.createForm();
  }

  public submit(): void {
    if (this.isSubmitting || this.form.invalid) {
      return;
    }

    this.isSubmitting = true;
    FormHelper.markAllAsDirty(this.form);
    this.submitEvent.emit(this.form.value);
    this.isSubmitting = false;
  }

  public getErrorMessage(key: string, control: FormControl): string {
    return FormHelper.getErrorMessage(key, control);
  }

  private watchForPasswordChange(): void {
    this.password.valueChanges
      .subscribe(() => this.passwordRepeat.updateValueAndValidity());
  }


  private createForm(): void {
    this.form = this.fb.group({
      email: ['', [
        Validators.required,
        customEmailValidator(),
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        PasswordValidator
      ]],
      pin: ['', [
        Validators.required,
        //Validators.minLength(8),
        PinValidator
      ]]
    });

    this.form.addControl('passwordRepeat', new FormControl('', [
      Validators.required,
      IsEqualWith.validate(this.password)
    ]));

    this.watchForPasswordChange();

    if (this.isProduction) {
      this.form.addControl('captcha', new FormControl('', Validators.required));
    }
  }
}
